import {
  Component,
  ElementRef,
  InputSignal,
  ViewChild,
  WritableSignal,
  effect,
  input,
  signal,
  untracked,
  viewChild,
} from '@angular/core';
import { HeroIconsComponent } from '@shared/components/ui/hero-icons';
import { NgClass } from '@angular/common';
import { IHeroIcons } from '@shared/components/ui/hero-icons';
import { TranslateModule } from '@ngx-translate/core';

enum eColors {
  primary = 'text-white bg-indigo-600',
  secondary = 'text-gray-700 dark:text-white bg-gray-200 dark:bg-gray-600',
  danger = 'text-white bg-red-600',
  info = 'text-white bg-blue-600',
  warning = 'text-white bg-yellow-600',
}

enum eLoadingColors {
  primary = 'text-white bg-indigo-500',
  secondary = 'text-gray-700 dark:text-white bg-gray-300 dark:bg-gray-500',
  danger = 'text-white bg-red-500',
  info = 'text-white bg-blue-500',
  warning = 'text-white bg-yellow-500',
}

type ColorType = 'primary' | 'secondary' | 'danger' | 'info' | 'warning';
@Component({
  selector: 'lib-old-button',
  templateUrl: './button.old.component.html',
  imports: [
    NgClass,
    HeroIconsComponent,
    TranslateModule
  ]
})
export class ButtonOldComponent {
public readonly progressBar = viewChild<ElementRef>('progressBar');
public text: InputSignal<string> = input<string>(null);
public readonly type: InputSignal<string> = input<string>('button');
public readonly disabled: InputSignal<boolean> = input<boolean>(false);
public readonly eColors = eColors;
public readonly eLoadingColors = eLoadingColors;

public fillCount: WritableSignal<number> = signal(0);
public timerCount: WritableSignal<number> = signal(0);
public fillInterval: ReturnType<typeof setInterval> = null;
public timerInterval: ReturnType<typeof setInterval> = null;

/**
 * An Input Signal to set the size of the icon to be displayed.
 * @type {number}
 * @default 6
 */
public readonly iconSize: InputSignal<number> = input<number>(6);
/**
 * The color theme of the button.
 * Can be one of 'primary', 'secondary', 'danger', 'info', or 'warning'.
 * @type {ColorType}
 * @default 'primary'
 */
public readonly color: InputSignal<ColorType> = input<ColorType>('primary');
/**
 * The name of the HeroIcons to be displayed.
 * @type {IHeroIcons['iconName']}
 */
public iconName: InputSignal<IHeroIcons['iconName']> = input<IHeroIcons['iconName']>(null);
/**
 *  The name of the flatIcon to be displayed.
 * @type {InputSignal<string>}
 */
public flatIcon: InputSignal<string> = input<string>(null);
  /**
   * An input signal to control state of loading animation.
   * @type {InputSignal<boolean>}
 */
  public loading: InputSignal<boolean> = input<boolean>(false);
  /**
 * An input signal to control if button should display a counter when a request was made.
 * @type {InputSignal<boolean>}
 */
  public timer: InputSignal<boolean> = input<boolean>(false);
  /**
 * An input signal to display custom text inside the button with timer.
 * Ex.: {{ timerText }} seconds
 * @default 'Wait {{ timerText }} seconds'
 * @type {InputSignal<string>}
 */
  public readonly timerText: InputSignal<string> = input<string>(null);
  /**
   * An effect to handle the side effects of state changes of input signal loading()
  */
  protected onLoadingChanges = effect(() => {
    if (this.loading()) {
      untracked(() => {
        if (this.timer()) {
          this.timerObj.start();
        }
        this.fillAnimation.start();
      })
    } else {
      untracked(() => {
        this.fillAnimation.stop()
      })
    }
  })

  /**
 * An object containing callBack methods to start and stop the timer.
 */
  public timerObj = {
    start: () => {
      this.timerCount.set(60);
      this.timerInterval = setInterval(() => {
        this.timerCount.update((prevCount) => prevCount - 1);
        if (this.timerCount() <= 0) {
          this.timerObj.stop();
        }
      }, 1000);
    },
    stop: () => {
      clearInterval(this.timerInterval)
      this.timerCount.set(null);
    },
  };

  /**
   * An object containing callBack methods to start and stop the loading fill animation.
   */

  public fillAnimation = {
    start: () => {
      this.fillCount.set(0);
      this.fillInterval = setInterval(() => {
        this.fillCount.update((prevCount) => prevCount + 0.5 );
        this.progressBar().nativeElement.style.transform = `translateX(${this.fillCount()}%)`;
      }, 10);
    },
    stop: () => {
      this.progressBar().nativeElement.style.transform = `translateX(100%)`;
      clearInterval(this.fillInterval);
      setTimeout(() => {
        this.progressBar().nativeElement.style.transform = '';
      }, 300);
    }
  }
}
